/* eslint-disable react/display-name */

import React from 'react';
import {Link} from 'react-router-dom';
import useStore from '../../hooks/useStore';

import PageWrapper from '../PageWrapper';

import {DefaultStyles} from './Home.styles';

const content = {
  en: {
    title: 'Water Table',
    firstParagraph: `Jordan is one of the most water scarce countries in the world. On
    average, 133 liters are available for each Jordanian per day for all
    uses—compared to water-rich countries where it can exceed 500
    liters.`,
    secondParagraph: `
    Explore how Jordan’s water sector developed over the years to ensure
    that all Jordanians have access to water in the face of scarcity.`,
  },
  ar: {
    title: 'طاولة الماء',
    firstParagraph: `الأردن واحد من أكثر البلدان التي تعاني من ندرة المياه في العالم. في المتوسط ، يتوفر 133 لترًا لكل أردني يوميًا لجميع الاستخدامات - مقارنة بالدول الغنية بالمياه حيث يمكن أن يتجاوز 500 لترًا.`,
    secondParagraph: `اكتشف كيف تطور قطاع المياه في الأردن على مر السنين لضمان ذلك
    أن كل الأردنيين يحصلون على المياه في مواجهة الندرة.`,
  },
};

const Home = () => {
  const {
    state: {lang},
  } = useStore();

  return (
    <PageWrapper>
      <DefaultStyles>
        <section className='content'>
          <h1>The Water Table</h1>
          <p>{content[lang].firstParagraph}</p>
          <p>{content[lang].secondParagraph}</p>
          <div className='links'>
            <Link to='/map'>
              {lang === 'en' ? 'Explore Map' : 'إكتشف الخريطة'}
            </Link>
            <Link to='/timeline'>
              {lang === 'en' ? 'Explore Timeline' : 'إكتشف الجدول الزمني'}
            </Link>
          </div>
        </section>
      </DefaultStyles>
    </PageWrapper>
  );
};

export default Home;
